export const GET_FAILED_REPORTS = "admin/GET_FAILED_REPORTS";
export const GET_FAILED_REPORTS_FAILURE = "admin/GET_FAILED_REPORTS_FAILURE";
export const GET_FAILED_REPORTS_SUCCESS = "admin/GET_FAILED_REPORTS_SUCCESS";
export const RESEND_REPORT = "admin/RESEND_REPORT";
export const RESEND_REPORT_SUCCESS = "admin/RESEND_REPORT_SUCCESS";
export const RESEND_REPORT_FAILURE = "admin/RESEND_REPORT_FAILURE";
export const REGENERATE_REPORT = "admin/REGENERATE_REPORT";
export const REGENERATE_REPORT_SUCCESS = "admin/REGENERATE_REPORT_SUCCESS";
export const REGENERATE_REPORT_FAILURE = "admin/REGENERATE_REPORT_FAILURE";
export const REGENERATE_SYSTEM_FAILURES = "admin/REGENERATE_SYSTEM_FAILURES";
export const REGENERATE_SYSTEM_FAILURES_SUCCESS =
  "admin/REGENERATE_SYSTEM_FAILURES_SUCCESS";
export const REGENERATE_SYSTEM_FAILURES_FAILURE =
  "admin/REGENERATE_SYSTEM_FAILURES_FAILURE";

export const getFailedReports = () => ({
  type: GET_FAILED_REPORTS
});

export const getFailedReportsFailure = () => ({
  type: GET_FAILED_REPORTS_FAILURE
});

export const getFailedReportsSuccess = (reports: any[]) => ({
  type: GET_FAILED_REPORTS_SUCCESS,
  payload: reports
});

export const resendReport = (
  merchant_id: number,
  report_id: number,
  report_file_id: number,
  process: string
) => ({
  type: RESEND_REPORT,
  payload: {
    merchant_id: merchant_id,
    report_id: report_id,
    report_file_id: report_file_id,
    process: process
  }
});

export const resendReportSuccess = (id: number) => ({
  type: RESEND_REPORT_SUCCESS,
  payload: id
});

export const resendReportFailure = (id: number) => ({
  type: RESEND_REPORT_FAILURE,
  payload: id
});

export const regenerateReport = (id: number) => ({
  type: REGENERATE_REPORT,
  payload: id
});

export const regenerateReportSuccess = (id: number) => ({
  type: REGENERATE_REPORT_SUCCESS,
  payload: id
});

export const regenerateReportFailure = (id: number) => ({
  type: REGENERATE_REPORT_FAILURE,
  payload: id
});

export const regenerateSystemFailures = () => ({
  type: REGENERATE_SYSTEM_FAILURES
});

export const regenerateSystemFailuresSuccess = () => ({
  type: REGENERATE_SYSTEM_FAILURES_SUCCESS
});

export const regenerateSystemFailuresFailure = () => ({
  type: REGENERATE_SYSTEM_FAILURES_FAILURE
});



// WEBPACK FOOTER //
// ./client/modules/Admin/actions.ts